var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColor01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.714px",
    height: "15.716px",
    viewBox: "79.614 140.86 15.714 15.716",
    enableBackground: "new 79.614 140.86 15.714 15.716",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M93.302,150.392l-0.392-0.495l-0.392,0.495c-0.339,0.428-2.027,2.622-2.027,3.785 c0,1.322,1.085,2.398,2.419,2.398c1.333,0,2.418-1.076,2.418-2.398C95.329,153.014,93.64,150.82,93.302,150.392z M92.911,155.59 c-0.785,0-1.424-0.633-1.424-1.412c0-0.507,0.74-1.718,1.424-2.658c0.683,0.939,1.423,2.15,1.423,2.658 C94.333,154.957,93.695,155.59,92.911,155.59z M90.905,150.496c0.237,0.101,0.476,0.17,0.698,0.17 c0.129,0,0.254-0.019,0.367-0.055c0.278-0.086,0.49-0.277,0.597-0.541c0.19-0.471,0.084-0.963-0.272-1.368 c0.181-0.851-0.096-1.586-0.812-2.046l-3.941-2.487l0.538-0.823l-2.342-1.504l-0.458,0.701l-2.251-1.379 c-0.959-0.615-2.385-0.262-3.046,0.754c-0.663,1.018-0.404,2.448,0.554,3.063l2.219,1.425l-0.488,0.747l2.342,1.504l0.554-0.847 l3.936,2.504c0.332,0.214,0.716,0.323,1.103,0.323c0.176,0,0.352-0.023,0.523-0.069C90.788,150.55,90.844,150.519,90.905,150.496z  M81.077,144.152c-0.503-0.323-0.627-1.133-0.258-1.698c0.368-0.564,1.167-0.784,1.679-0.456l2.241,1.373l-1.442,2.206 L81.077,144.152z M84.316,147.291l-0.673-0.431l2.389-3.653l0.671,0.431L84.316,147.291z M89.637,149.483l-3.933-2.503L87,144.997 l3.945,2.49c0.604,0.387,0.433,1.059,0.183,1.555c-0.15,0.298-0.38,0.497-0.666,0.573 C90.188,149.689,89.886,149.642,89.637,149.483z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor01);
export default __webpack_public_path__ + "static/media/icon_color-01.4b6b408918ebee7f16b30fa85f74e907.svg";
export { ForwardRef as ReactComponent };